// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"7f39a6d9","171":"824e019a","374":"bdde9d4a","453":"af897257","466":"178c0510","507":"bd2f57b8","628":"1e515be1","801":"13c36a32","845":"f7df4311","870":"5e0908c8"}[chunkId] + ".chunk.js";
};